import { useEffect } from 'react'
// import { isMobileSafari } from 'react-device-detect'

import config from 'config'
// import { useLocation } from 'react-router-dom'

const ITUNES_META_TAG = 'apple-itunes-app'

const addMetaTag = (name, content) => {
  const metaTag = document.querySelector(`meta[name="${name}"]`)
  if (metaTag) {
    metaTag.setAttribute('content', content)
  } else {
    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.getElementsByTagName('head')[0].appendChild(meta)
  }
}

const removeMetaTag = name => document.querySelector(`meta[name="${name}"]`)?.remove()

const useSmartBanner = () => {
  // const { pathname } = useLocation()

  useEffect(() => {
    /*
    if (pathname.startsWith('/events')) {
      return removeSmartBanner()
    }
     */

    updateSmartBanner()
    window.scrollTo(0, -100)
    return removeSmartBanner
  }, [])

  const updateSmartBanner = () => {
    if (window.Cypress) {
      return
    }

    // const encodedPageUrl = encodeURIComponent(window.location.href)
    const smartBannerMetaContent = `app-id=${config.ios.appId}, app-clip-bundle-id=${config.ios.appClipBundleId}, app-clip-display=card`

    addMetaTag(ITUNES_META_TAG, smartBannerMetaContent)
  }

  const removeSmartBanner = () => {
    if (window.Cypress) {
      return
    }

    removeMetaTag(ITUNES_META_TAG)
  }
}

export default useSmartBanner
